import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { SCREENSHOT_TYPES } from "../utils/screenshotUtils";

export default function ScreenshotDownloadDialog({
  open,
  onClose,
  onDownload,
  downloading = false,
}) {
  const [selectedType, setSelectedType] = useState(SCREENSHOT_TYPES.IR);

  const handleClose = () => {
    if (downloading) {
      return;
    }
    onClose();
  };

  const handleDownload = () => {
    onDownload(selectedType);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Select which Screenshot you want to download</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset" fullWidth disabled={downloading}>
          <RadioGroup
            value={selectedType}
            onChange={(event) => setSelectedType(event.target.value)}
          >
            <FormControlLabel
              value={SCREENSHOT_TYPES.IR}
              control={<Radio />}
              label="IR image"
            />
            <FormControlLabel
              value={SCREENSHOT_TYPES.BSCAN_CURRENT}
              control={<Radio />}
              label="Bscan (only current)"
            />
            <FormControlLabel
              value={SCREENSHOT_TYPES.ALL_BSCANS}
              control={<Radio />}
              label="ALL Bscans"
            />
          </RadioGroup>
        </FormControl>
        {downloading ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
          >
            <CircularProgress size={16} />
            Preparing screenshot download...
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={downloading}>
          Cancel
        </Button>
        <Button
          onClick={handleDownload}
          variant="contained"
          disabled={downloading}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
}
